<div class="card">
  <!-- show only if its having only one user -->
  <div *ngIf="applicantRequests.length === 1">
    <ng-container *ngFor="let applicantRequest of applicantRequests">
      <span class="customer-name" id="applicantTab_{{ applicantRequest.applicantId }}">
      {{ applicantRequest.firstName }} {{ applicantRequest.lastName }}
      </span>
      <div class="tab-bottom-line"></div>
    </ng-container>
  </div>
  <!-- show if its having with morethan one user -->
  <mat-tab-group
    (selectedTabChange)="socureTabChange($event)"
    [selectedIndex]="activeTabIndex"
    *ngIf="applicantRequests.length > 1"
  >
    <div *ngFor="let applicantRequest of applicantRequests">
      <mat-tab
        label="{{ applicantRequest.firstName }} {{ applicantRequest.lastName }}"
        id="applicantTab_{{ applicantRequest.applicantId }}"
      >
      </mat-tab>
    </div>
  </mat-tab-group>
  <div
    *ngFor="
      let applicantRequest of applicantRequests;
      let indexOfElements = index
    "
  >
    <div
      class="applicant-tab-area"
      [hidden]="indexOfElements != activeTabIndex"
      fxFlex
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <!-- Initial Dialog to Customer -->
      <div
        id="socure-initial-dialog"
        *ngIf="
          socureApplicantStatusMap.has(applicantRequest.applicantId!) &&
          (socureApplicantStatusMap.get(applicantRequest.applicantId!)!
            .status === '' ||
            socureApplicantStatusMap.get(applicantRequest.applicantId!)!
              .status === 'WAITING_FOR_REDIRECT_METHOD' ||
            socureApplicantStatusMap.get(applicantRequest.applicantId!)!
              .status === 'WAITING_FOR_USER_TO_REDIRECT')
        "
      >
        <div
          fxLayout
          fxLayout.xs="column"
          fxLayoutAlign="center"
          fxLayoutGap="50px"
          fxLayoutGap.xs="0"
        >
          <div class="socure-sub-area">
            <h3><div class="socure-sub-label">Continue on your phone</div></h3>
            <br /><br />
            <div class="socure-sub-label-detail">Link has been sent to:</div>
            <div>
              <span class="phone-number-area">{{
                applicantRequest.phoneNumber! | mask : "000-000-0000"
              }}</span>
            </div>
            <br />
          </div>
          <h3><div class="option-label">or</div></h3>
          <div class="socure-sub-area">
            <h3>
              <div class="socure-sub-label">Didn't receive the text?</div>
            </h3>
            <br /><br />
            <div class="socure-sub-label-detail">Use this QR Code:</div>
            <div>
              <img
                class="socure-qr-code"
                [src]="
                  sanitizeImageUrl(
                    socureApplicantStatusMap.get(applicantRequest.applicantId!)!
                      .qrCode!
                  )
                "
                alt="Socure Document Capture QR Code"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- In Progress -->
      <div
        id="socure-progress-dialog"
        *ngIf="
          socureApplicantStatusMap.has(applicantRequest.applicantId!) &&
          socureApplicantStatusMap.get(applicantRequest.applicantId!)!.status !=
            '' &&
          socureApplicantStatusMap.get(applicantRequest.applicantId!)!.status !=
            'WAITING_FOR_REDIRECT_METHOD' &&
          socureApplicantStatusMap.get(applicantRequest.applicantId!)!.status !=
            'WAITING_FOR_USER_TO_REDIRECT' &&
          socureApplicantStatusMap.get(applicantRequest.applicantId!)!.status !=
            'SESSION_COMPLETE'
        "
      >
        <div
          role="img"
          aria-label="Document capture is in process"
          id="document-update-in-progress-area"
        >
          &nbsp;
        </div>
      </div>

      <div
        id="applicant-finished-dialog"
        *ngIf="
          applicantRequests.length > 1 &&
          socureApplicantStatusMap.get(applicantRequest.applicantId!)!.status ==
            'SESSION_COMPLETE'
        "
      >
        <div class="checkbox-area">
          <mat-icon
            class="completedCheckmark icon-centered document-upload-complete-icon"
            svgIcon="check_circle"
          ></mat-icon>
        </div>
        <div class="socure-sub-label">Document Upload Complete</div>
        <br /><br />
        <div class="socure-sub-label-detail" *ngIf="indexOfElements === 0">
          Please wait for {{ applicantRequests[1].firstName }}
          {{ applicantRequests[1].lastName }} to complete the upload process.
        </div>
        <div class="socure-sub-label-detail" *ngIf="indexOfElements === 1">
          Please wait for {{ applicantRequests[0].firstName }}
          {{ applicantRequests[0].lastName }} to complete the upload process.
        </div>
      </div>
    </div>
  </div>
</div>
